const en = require('./en');
const { SUPPORTED_LANGUAGES } = require('../const');

module.exports = {
    [SUPPORTED_LANGUAGES.EN]: { ...en }
};
